/**
 * Криптостойкий пароль для embed (регистрация / сброс / смена в ЛК / первый пароль клиента, созданного сотрудником).
 * Формат `AbCd12-AbCd12-AbCd12`: три группы по 6 символов (2 строчных, 2 прописных, 2 цифры), разделённые дефисом.
 * Удовлетворяет политике API: ≥12 символов, строчная + прописная + цифра.
 */

const LOWER = 'abcdefghijklmnopqrstuvwxyz';
const UPPER = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const DIGITS = '0123456789';

function randomUIntBelow(maxExclusive: number): number {
  const buf = new Uint32Array(1);
  crypto.getRandomValues(buf);
  return buf[0]! % maxExclusive;
}

function pickOne(chars: string): string {
  return chars[randomUIntBelow(chars.length)]!;
}

/** Группа `AbCd12`: 2 прописных, 2 строчных, 2 цифры. */
function generateGroup(): string {
  return (
    pickOne(UPPER) +
    pickOne(LOWER) +
    pickOne(UPPER) +
    pickOne(LOWER) +
    pickOne(DIGITS) +
    pickOne(DIGITS)
  );
}

/** Случайный пароль формата `AbCd12-AbCd12-AbCd12` (20 символов). */
export function generateEmbedPassword(): string {
  return [generateGroup(), generateGroup(), generateGroup()].join('-');
}
